/**
 * A generic HTML element that contains common properties
 */
export interface HTMLListItem extends HTMLElement {
    selected: boolean;
    disabled: boolean;
    value: string;
}

/**
 * An adapter provides the connection between a component and a behavior
 */
export interface Adapter<T> {
    getItems(): T[];
    getSelectedItem(): T | null;
    setValue(value: any): void;
    notifySelect?(item: T): void;
}

/**
 * A behavior encapsulates interaction and value synchronisation
 */
export interface SelectionBehavior {
    clearValue(): void;
    setValue(value: any): void;
    select(item: any): void;
}
